import { jsx } from 'react/jsx-runtime';
import { useMemo, useRef, useEffect } from 'react';
import { usePDFContent } from './PDF.js';
import TinyPage from './TinyPage.js';
import { styled } from 'styled-components';

const Pages = styled.div.withConfig({
  displayName: "TinyPagesList__Pages",
  componentId: "sc-4fd99b51-0"
})([
  `border-radius:14px;display:flex;flex-direction:column;padding:14px 10px;gap:22px;width:100%;position:relative;z-index:2;max-height:100%;margin:0;margin-right:8px;`
]);
const TinyPagesList = ({ pageWidth }) => {
  const { pdf, tinyPagesVisible, currentPage, scrollToPage, setTinyPagesRef, tinyPagesRef, scrollToTinyPage, setCurrentPage } = usePDFContent();
  const pdfPages = useMemo(() => Array.from(Array(pdf?.numPages ?? 0).keys()), [
    pdf
  ]);
  const prevTinyPagesVisible = useRef(tinyPagesVisible);
  const stateDebounce = useRef(null);
  useEffect(() => {
    if (prevTinyPagesVisible.current === tinyPagesVisible) return;
    if (stateDebounce.current) clearTimeout(stateDebounce.current);
    stateDebounce.current = window.setTimeout(() => {
      scrollToTinyPage?.(currentPage);
      prevTinyPagesVisible.current = tinyPagesVisible;
    }, 300);
  }, [
    currentPage,
    tinyPagesVisible,
    scrollToTinyPage
  ]);
  return /* @__PURE__ */ jsx(Pages, {
    ref: setTinyPagesRef,
    children: tinyPagesRef && pdfPages.map((index) => {
      const pageNumber = index + 1;
      return /* @__PURE__ */ jsx(TinyPage, {
        pageNumber,
        width: pageWidth,
        onClick: () => {
          if (scrollToPage) {
            scrollToPage(pageNumber);
          } else {
            setCurrentPage(pageNumber);
          }
        }
      }, pageNumber);
    })
  });
};

export { TinyPagesList as default };
//# sourceMappingURL=TinyPagesList.js.map
